<template>
  <div>
  <v-alert
                class="trainee-alert mb-6 mx-4 mt-6"
                colored-border
                elevation="2"
                type="info"
            >
              If given Trainee does not exist, Please make sure the trainee is
              registered here.
              <span class="mx-4">
                <!-- <a href>http://ihris.sandboxaddis.com</a>
        <b>OR</b> -->
                <v-btn
                    class="
                    trainee-alert__button
                    bg-gray-200
                    hover:bg-blue-700
                    text-black
                    font-light
                    py-2
                    px-4
                    rounded
                    focus:outline-none
                    focus:shadow-outline
                  "
                    type="button"
                    @click="goToTraineeHistory"
                >Go to Trainee History</v-btn
                >
              </span>
            </v-alert>
            <v-toolbar
                v-if="canCreateTrainee"
                class="
                trainee-toolbar
                headline
                font-weight-regular
                blue-grey
                white--text
                mb-6
                mx-4
                mt-6
              "
                dark
            >
              <v-toolbar-title>Assign Course</v-toolbar-title>
              <v-autocomplete
                  v-model="newTraineesSelect"
                  :items="newTraineeItems"
                  :loading="loading"
                  :search-input.sync="newTraineeSearch"
                  class="trainee-toolbar__search mx-4"
                  clearable
                  flat
                  hide-details
                  hide-no-data
                  hide-selected
                  :item-text="getNewTraineeSearchLabel"
                  label="Search trainee using name, phone, license, or FAN"
                  no-filter
                  prepend-icon="mdi-database-search"
                  return-object
                  solo-inverted
              ></v-autocomplete>
            </v-toolbar>
            <template>
              <v-dialog v-model="newTraineeCourseDialog" persistent width="60%">
                <v-card class="trainee-dialog-card">
                  <v-card-title
                      class="trainee-dialog__title"
                      primary-title
                  >
                    <v-icon class="trainee-dialog__icon">mdi-account-plus</v-icon>
                    <span class="trainee-dialog__text">Assign New Trainee Course</span>

                    <v-spacer></v-spacer>

                    <v-btn class="trainee-dialog__close" icon @click="closeDialog(true)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title
                  >
                  <v-divider></v-divider>
                  <HrdUpdateNewTrainee
                      v-if="newTraineeCourseDialog"
                      :newTrainee="newTrainee"
                      @close="newTraineeCourseDialog = false"
                      @registerOrUpdateNewTrainee="registerOrUpdateNewTrainee"
                  ></HrdUpdateNewTrainee>
                </v-card>
              </v-dialog>
            </template>
            <template>
              <v-dialog v-model="newTCourseDetailDialog" persistent width="60%">
                <v-card class="trainee-dialog-card">
                  <v-card-title
                      class="trainee-dialog__title"
                      primary-title
                  >
                    <v-icon class="trainee-dialog__icon">mdi-account-details-outline</v-icon>
                    <span class="trainee-dialog__text">{{ title }}</span>

                    <v-spacer></v-spacer>

                    <v-btn class="trainee-dialog__close" icon @click="closeDialog(true)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title
                  >
                  <v-divider></v-divider>
                  <HrdNewTraineeDetail
                      v-if="newTCourseDetailDialog"
                      :newTrainee="newTrainee"
                      :traineStatusIds="traineStatusIds"
                      :traineeStatus="traineeStatus"
                      @close="newTCourseDetailDialog = false"
                  ></HrdNewTraineeDetail>
                </v-card>
              </v-dialog>
            </template>
            <v-card class="trainee-section mx-4" flat>
              <v-card-title class="trainee-section__title">
                New Trainees Courses
                <br/>
                <v-layout align-self-center class="trainee-filter-grid p-3" row wrap>
                  <v-flex class="p-2" xs12 sm6 md2>
                    <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" max-width="290px"
                            min-width="290px" offset-y transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="startDate" :clearable="true" label="Pick start date"
                                      persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker
                          ref="startDate" v-model="startDate"
                          :max="endDate ? endDate : null" no-title scrollable
                          @input="startMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm6 md2>
                    <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" :return-value.sync="date"
                            min-width="290px" offset-y transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="endDate" :clearable="true" label="Pick end date" prepend-icon="event"
                                      readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="endDate" :min="startDate" no-title
                                     scrollable @input="endMenu = false">
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm6 md2>
                    <v-autocomplete
                        v-model="categoryId"
                        :clearable="true"
                        :items="CATEGORIES"
                        :loading="categoryLoading"
                        item-text="name"
                        item-value="id"
                        label="Cpd activity Category">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm6 md2>
                    <v-autocomplete
                        v-model="cpdActivityId"
                        :clearable="true"
                        :items="CPD_ACTIVITIES"
                        :loading="cpdActLoading"
                        item-text="name"
                        item-value="id"
                        label="Cpd activity">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm6 md2>
                    <v-autocomplete
                        v-model="statusValue"
                        :clearable="true"
                        :items="statusOptions"
                        item-text="name"
                        item-value="id"
                        label="Status">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm6 md2>
                    <v-select
                        v-model="categoryTypeValue"
                        :clearable="true"
                        :items="CATEGORY_TYPES"
                        item-text="text"
                        item-value="value"
                        label="Category Type"
                    ></v-select>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm6 md2>
                    <v-text-field
                        v-model="filterTrainee"
                        clearable
                        append-icon="mdi-magnify"
                        hide-details
                        label="Search name, phone, FAN, or license"
                        single-line
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <div class="trainee-approve-row" v-if="canShowApprovalActions">
                  <v-btn
                      class="trainee-approve-button teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      :disabled="selectionLoading || selected.length === 0"
                      @click="handleApprove"
                  >
                    <v-icon left>mdi-check-circle</v-icon>
                    <span>Approve</span>
                  </v-btn>
                </div>
                <div class="trainee-approve-row" v-if="canShowBulkCertificateActions">
                  <v-btn
                      class="trainee-approve-button teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      :disabled="selectionLoading || bulkCertificateItems.length === 0"
                      @click="openBulkCertificateDialog"
                  >
                    <v-icon left>mdi-file-certificate-outline</v-icon>
                    <span>Generate Certificates</span>
                  </v-btn>
                </div>
              </v-card-title>
              <div v-if="selectionLoading || selected.length" class="px-4 py-2" role="status">
                {{ selectionLoading ? 'Selecting trainees across all pages…' : selected.length + ' trainees selected across all pages' }}
              </div>
              <v-data-table
                  :headers="newTraineeTableHeaders"
                  :items="selectableNewTraineeRows"
                  :loading="newTraineeLoading"
                  :options.sync="options"
                  :server-items-length="newTrainees.count"
                  class="trainee-table elevation-1"
                  loading-text="Loading... please wait"
                  :show-select="canShowApprovalActions || canShowBulkCertificateActions"
                  v-model="selected"
              >
                <template v-slot:[`header.data-table-select`]>
                  <v-simple-checkbox
                      :value="allTraineesSelected"
                      :indeterminate="selected.length > 0 && !allTraineesSelected"
                      :disabled="selectionLoading || newTraineeLoading || approvalLoading || bulkCertificateLoading"
                      aria-label="Select all matching trainees across all pages"
                      title="Select all matching trainees across all pages"
                      @input="toggleSelectAllTrainees"
                  />
                </template>
                <template v-slot:[`item.trainee.fullName`]="{ item }">
                  <label for="item">
                    {{
                      item.trainee
                          ? item.trainee.prefix
                              ? item.trainee.prefix
                              : ""
                          : ""
                    }}
                    {{
                      item.trainee
                          ? item.trainee.firstName
                              ? item.trainee.firstName
                              : "-"
                          : "-"
                    }}
                    {{
                      item.trainee
                          ? item.trainee.middleName
                              ? item.trainee.middleName
                              : "-"
                          : "-"
                    }}
                    {{
                      item.trainee
                          ? item.trainee.lastName
                              ? item.trainee.lastName
                              : "-"
                          : "-"
                    }}</label
                  >
                </template>
                <template v-slot:[`item.trainee.gender`]="{ item }">
                  <label for="item">{{
                      item.trainee
                          ? item.trainee.gender
                              ? item.trainee.gender
                              : "-"
                          : "-"
                    }}</label>
                </template>
                <template v-slot:[`item.trainee.phoneNumber`]="{ item }">
                  <label for="item">{{
                      item.trainee
                          ? item.trainee.phoneNumber
                              ? item.trainee.phoneNumber
                              : "-"
                          : "-"
                    }}</label>
                </template>
                <template v-slot:[`item.trainee.healthProfession`]="{ item }">
                  <label for="item">{{
                      item.trainee
                          ? item.trainee
                              ? item.trainee.healthProfession
                                  ? item.trainee.healthProfession.name
                                  : "-"
                              : "-"
                          : "-"
                    }}</label>
                </template>

                <template v-slot:[`item.courseScore`]="{ item }">
                  <label
                      v-if="isCat2NewTrainee(item)"
                      :class="['trainee-score-label', {'trainee-score-label--failed': isFailedNewTrainee(item)}]"
                      for="item"
                      @click="handleFailedNewTraineeClick(item)"
                  >
                    {{ getNewTraineeScoreDisplay(item) }}
                  </label>
                  <div
                      v-else
                      :class="['d-flex align-center justify-center trainee-score-cell', {'trainee-score-cell--failed': isFailedNewTrainee(item)}]"
                      style="gap: 6px;"
                      @click="handleFailedNewTraineeClick(item)"
                  >
                    <v-text-field
                        :value="getScoreEditForNewTrainee(item)"
                        :class="['trainee-score-input', {'trainee-score-input--failed': isFailedNewTrainee(item)}]"
                        :disabled="!canEditScoreNewTrainee(item)"
                        type="number"
                        min="0"
                        max="100"
                        dense
                        hide-details
                        style="max-width: 110px;"
                        placeholder="-"
                        @input="onScoreInputNewTrainee(item, $event)"
                    />
                    <v-btn
                        v-if="!isCat2NewTrainee(item) && !hasGeneratedCertificateNewTrainee(item)"
                        icon
                        small
                        :disabled="!canEditScoreNewTrainee(item) || isScoreSavingNewTrainee(item)"
                        @click="saveScoreNewTrainee(item)"
                    >
                      <v-icon small>mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                          class="trainee-action-icon mr-2"
                          style="color: teal"
                          @click="viewNewTrainee(item)"
                          v-on="on"
                      >mdi-eye
                      </v-icon>
                    </template>
                    <span>View New Trainee</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-if="canEditTrainee(item?.new_trainees_course?.traineeStatusId ??
                    item?.newt_cat2_course?.traineeStatusId ?? null)" v-slot:activator="{ on }">
                      <v-icon
                          class="trainee-action-icon mr-2"
                          style="color: teal"
                          @click="editNewTrainee(item)"
                          v-on="on"
                      >mdi-circle-edit-outline
                      </v-icon>
                    </template>
                    <span>Edit New Trainee</span>
                  </v-tooltip>
                  <v-tooltip v-if="canEditCertificateReasonNew(item)" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                          class="trainee-action-icon mr-2"
                          style="color: teal"
                          @click="openCertificateReasonDialogNew(item)"
                          v-on="on"
                      >mdi-note-edit-outline
                      </v-icon>
                    </template>
                    <span>Edit Certificate Reason</span>
                  </v-tooltip>
                  <v-tooltip v-if="canGenerateCertificateNewTrainee(item)" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                          class="trainee-action-icon mr-2"
                          :style="{ color: isCertificatePendingApprovalNew(item) ? '#f59e0b' : 'teal' }"
                          @click="viewCertificateFromRow(item)"
                          v-on="on"
                      >{{ getCertificateActionIconNew(item) }}
                      </v-icon>
                    </template>
                    <span>{{ getCertificateActionTooltipNew(item) }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="canShowRowApprovalAction(item)" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                          class="trainee-action-icon mr-2"
                          style="color: #2e7d32"
                          @click="approveSingle(item)"
                          v-on="on"
                      >mdi-check-circle-outline
                      </v-icon>
                    </template>
                    <span>Approve Certificate</span>
                  </v-tooltip>
                  <v-tooltip v-if="canShowRowSigningAction(item)" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                          class="trainee-action-icon mr-2"
                          style="color: #1565c0"
                          @click="signSingle(item)"
                          v-on="on"
                      >mdi-draw-pen
                      </v-icon>
                    </template>
                    <span>Sign Certificate</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
            <v-dialog v-model="showCertificateReasonDialog" max-width="560">
              <v-card>
                <v-card-title>Edit Certificate Reason</v-card-title>
                <v-card-text>
                  <v-select
                      v-model="certificateReasonForm.reasonId"
                      :items="CERTIFICATE_REASONS"
                      :loading="certReasonLoading"
                      item-text="name"
                      item-value="id"
                      label="Certificate Reason"
                      clearable
                      outlined
                      dense
                  ></v-select>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text :disabled="certReasonLoading" @click="closeCertificateReasonDialogNew">Cancel</v-btn>
                  <v-btn
                      color="primary"
                      :disabled="certReasonLoading || !certificateReasonForm.reasonId"
                      @click="saveCertificateReasonNew"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="showApprovalDialog" max-width="640">
              <v-card>
                <v-card-title>Approve Certificates</v-card-title>
                <v-card-text>
                  <div class="mb-2">
                    Selected trainees: <strong>{{ selected.length }}</strong>
                  </div>
                  <v-alert
                      v-if="selected.length !== 1"
                      type="info"
                      dense
                      outlined
                      class="mb-3"
                  >
                    Select exactly one trainee to preview a certificate.
                  </v-alert>
                  <div class="d-flex align-center mb-4">
                    <v-btn
                        color="primary"
                        text
                        small
                        :disabled="selected.length !== 1 || previewLoading"
                        @click="previewCertificate"
                    >
                      <v-icon left>mdi-file-eye</v-icon>
                      View Certificate
                    </v-btn>
                    <v-progress-circular
                        v-if="previewLoading"
                        indeterminate
                        size="18"
                        class="ml-2"
                    />
                  </div>
                  <v-checkbox
                      v-model="approvalOptions.sendEmail"
                      label="Send certificate via email after approval"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="closeApprovalDialog">Cancel</v-btn>
                  <v-btn
                      color="primary"
                      :loading="approvalLoading"
                      :disabled="approvalLoading"
                      @click="confirmApprove"
                  >
                    Approve
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="showBulkCertificateDialog" max-width="720">
              <v-card>
                <v-card-title>Generate Certificates</v-card-title>
                <v-card-text>
                  <div class="mb-2">
                    Trainees to process: <strong>{{ bulkCertificateItems.length }}</strong>
                  </div>
                  <v-alert
                      v-if="bulkCertificateItems.length !== 1"
                      type="info"
                      dense
                      outlined
                      class="mb-3"
                  >
                    Select exactly one trainee to preview a certificate.
                  </v-alert>
                  <div class="d-flex align-center mb-4">
                    <v-btn
                        color="primary"
                        text
                        small
                        :disabled="bulkCertificateItems.length !== 1 || bulkCertificateLoading"
                        @click="previewSelectedCertificate"
                    >
                      <v-icon left>mdi-file-eye</v-icon>
                      View Certificate
                    </v-btn>
                    <v-progress-circular
                        v-if="bulkCertificateLoading && bulkCertificateProgress.total"
                        indeterminate
                        size="18"
                        class="ml-2"
                    />
                  </div>

                  <v-alert
                      v-if="bulkCertificateErrors.length"
                      type="warning"
                      dense
                      outlined
                      class="mb-3"
                  >
                    {{ bulkCertificateErrors.join(' ') }}
                  </v-alert>

                  <div v-if="bulkCertificateProgress.total" class="mb-3">
                    Processing: {{ bulkCertificateProgress.current }} / {{ bulkCertificateProgress.total }}
                    <v-progress-linear
                        :value="bulkCertificateProgressPercent"
                        height="6"
                        rounded
                    ></v-progress-linear>
                  </div>

                  <v-alert type="info" dense outlined class="mb-0">
                    Option 1 downloads a ZIP with one standalone PDF per trainee. Option 2 sends the certificate to each trainee's email.
                  </v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text :disabled="bulkCertificateLoading" @click="closeBulkCertificateDialog">Cancel</v-btn>
                  <v-btn
                      color="primary"
                      :loading="bulkCertificateLoading && bulkCertificateMode === 'download'"
                      :disabled="bulkCertificateLoading || bulkCertificateItems.length === 0"
                      @click="runBulkCertificates('download')"
                  >
                    Generate ZIP
                  </v-btn>
                  <v-btn
                      color="primary"
                      :loading="bulkCertificateLoading && bulkCertificateMode === 'email'"
                      :disabled="bulkCertificateLoading || bulkCertificateItems.length === 0"
                      @click="runBulkCertificates('email')"
                  >
                    Send By Email
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
  </div>
</template>

<script>
import {TraineeService} from "../trainees.service";
import createTraineeTableSelection from "../traineeTableSelection";
import HrdUpdateNewTrainee from "./hrd-update-new-trainee.vue";
import HrdNewTraineeDetail from "./hrd-new-trainee-detail.vue";

import {generateCertificate1, resolveCertificateEmail} from "../generate-certiificate";
import {
  getCategories,
  getCertReason,
  hasCertificateApprovalPermission,
  hasCertificateSigningPermission,
  isCertificateApprovalComplete,
  isCertificateUnapproved,
  TRAINEE_STATUS_FILTERS,
  traineeStatusQuery,
  isCertificatePendingCoordinatorSignature,
  getProgramsDrp,
  getUser,
} from "@/utils/helper";
import {settings} from "@/Settings";
import JSZip from "jszip";

const {saveAs} = require("file-saver");

export default {
  mixins: [createTraineeTableSelection({
    canSelectMethod: "canSelectNewTraineeRow",
    request: (params) => TraineeService.getNewTraineeAssignList(params),
  })],
  props: {
    fromRoute: String,
  },
  components: {
    HrdUpdateNewTrainee,
    HrdNewTraineeDetail,
  },
  data() {
    return {
      CATEGORIES: [],
      CPD_ACTIVITIES: [],
      STATUS: TRAINEE_STATUS_FILTERS,
      CERTIFICATE_REASONS: [],
      CATEGORY_TYPES: [
        {text: "Cat I", value: "CAT1"},
        {text: "Cat II", value: "CAT2"},
      ],
      cpdActLoading: false,
      categoryLoading: false,
      statusLoading: false,
      certReasonLoading: false,

      startDate: null,
      endDate: null,
      cpdActivityId: null,
      categoryId: null,
      statusValue: null,
      categoryTypeValue: null,
      filterTrainee: null,

      loading: false,
      selected: [],
      items: [],
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      entries: [],
      cpdActivity: null,
      search: null,
      searchDebounce: null,
      startMenu: false,
      newTraineeStartMenu: null,
      newTraineeEndMenu: null,
      date: '',
      newTraineesSearch: '',
      newTraineesSearchDebounce: null,
      newTraineeStartDate: '',
      endMenu: false,
      newTraineeEndDate: '',
      searchTrainee: null,
      select: null,
      dialog: false,
      detailDialog: false,
      traineeNotFound: false,
      traineStatusIds: {passId: "", failId: ""},
      traineeStatus: [],
      headers: [
        {text: "Full Name", value: "person.fullName"},
        {text: "Gender", value: "person.gender"},
        // { text: "Birth Date", value: "person.birthdate" },
        // {
        //   text: "Profession",
        //   value: "person.employee_job_history.jobtitlename",
        // },
        {text: "License Number", value: "person.licenseNumber"},
        {text: "Tin Number", value: "person.tin"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      export_fields: {
        "First Name": "person.firstname",
        "Middle Name": "person.middlename",
        "Last Name": "person.lastname",
        Gender: "person.gender",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.courseName" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.continualEducationUnit" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.ceu" : " "),
      },
      export_new_trainee_fields: {
        "First Name": "trainee.firstName",
        "Middle Name": "trainee.middleName",
        "Last Name": "trainee.lastName",
        phoneNumber: "trainee.phoneNumber",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.courseName" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.continualEducationUnit" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.ceu" : " "),
      },
      trainees: [],
      showTable: false,
      trainee: null,
      tab: null,
      tabItems: ["Trainees from HRA", "Newly Registered Trainees"],
      newTraineesSelect: null,
      newTraineeCourseDialog: false,
      newTraineeNotFound: false,
      newTrainee: null,
      newTraineeItems: [],
      newTrainees: [],
      newTraineeSearch: null,
      newTraineeSearchDebounce: null,
      searchNewTrainee: null,
      newTCourseDetailDialog: false,
      newTraineeheaders: [
        {text: "Full Name", value: "trainee.fullName"},
        {text: "Phone Number", value: "trainee.phoneNumber"},
        {text: "Gender", value: "trainee.gender"},
        {
          text: "Profession",
          value: "trainee.healthProfession.name",
        },
        {text: "Score", value: "courseScore", sortable: false, align: "center"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      historyLoading: false,
      newTraineeLoading: false,

      showApprovalDialog: false,
      showCertificateReasonDialog: false,
      certificateReasonForm: {
        item: null,
        reasonId: null,
      },
      approvalOptions: {
        sendEmail: false,
      },
      approvalLoading: false,
      previewLoading: false,

      showBulkCertificateDialog: false,
      bulkCertificateLoading: false,
      bulkCertificateMode: null, // 'download' | 'email'
      bulkCertificateProgress: {total: 0, current: 0},
      bulkCertificateErrors: [],

      // Inline score entry per row: key = `${type}:${id}` (type: 'cat1' | 'cat2')
      scoreEdits: {},
      scoreSaving: {},
    };
  },
  watch: {
    search(val) {
      if (this.select && this.items.length > 0) return;
      const text = (val || "").toString().trim();
      if (!text) {
        this.traineeNotFound = false;
        return;
      }
      if (text.length < 3) {
        return;
      }
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = null;
      }
      this.searchDebounce = setTimeout(() => {
        val && val !== this.select && this.querySelections(val);
      }, 400);
    },
    options: {
      handler() {
        this.fetchNewTraineeCourseList();
      },
      deep: true,
    },
    //
    filterTrainee: function (val) {
      this.filterTrainee = val;
      this.fetchNewTraineeCourseList();
    },
    startDate: function (val) {
      this.startDate = val;
      this.fetchNewTraineeCourseList();
    },
    endDate: function (val) {
      this.endDate = val;
      this.fetchNewTraineeCourseList();
    },
    categoryId: function (val) {
      this.categoryId = val;
      this.fetchCpdActivity(this.categoryId);
      this.fetchNewTraineeCourseList();
    },
    cpdActivityId: function (val) {
      this.cpdActivityId = val;
      this.fetchNewTraineeCourseList();
    },
    statusValue: function (val) {
      this.statusValue = val;
      this.selected = [];
      if (this.options.page !== 1) {
        this.options.page = 1;
      } else {
        this.fetchNewTraineeCourseList();
      }
    },
    categoryTypeValue: function (val) {
      this.categoryTypeValue = val;
      if (val === "CAT2" && this.statusValue === "FAIL") {
        this.statusValue = null;
        return;
      }
      this.fetchNewTraineeCourseList();
    },
    online: function (val) {
      this.online = val;
      this.fetchNewTraineeCourseList();
    },
    //

    newTraineesSearch: function (val) {
      if (this.newTraineesSearchDebounce) {
        clearTimeout(this.newTraineesSearchDebounce);
        this.newTraineesSearchDebounce = null;
      }
      const text = (val || "").toString().trim();
      if (text.length === 0) {
        this.fetchNewTraineeCourseList();
        return;
      }
      if (text.length < 3) {
        return;
      }
      this.newTraineesSearchDebounce = setTimeout(() => {
        this.fetchNewTraineeCourseList();
      }, 400);
    },
    newTraineeStartDate: function (val) {
      if (val == null) {
        this.newTraineeStartDate = ''
      } else {
        this.newTraineeStartDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    newTraineeEndDate: function (val) {
      if (val == null) {
        this.newTraineeEndDate = ''
      } else {
        this.newTraineeEndDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    select(val) {
      val != null
          ? ((this.dialog = true),
              (this.traineeNotFound = false),
              (this.trainee = val))
          : (this.dialog = false);

      this.dialog == true ? (this.title = "Assign Trainee Course") : null;
    },
    newTraineeSearch(val) {
      if (this.newTraineesSelect && this.newTraineeItems.length > 0) return;
      const text = (val || "").toString().trim();
      if (!text) {
        this.newTraineeNotFound = false;
        return;
      }
      if (text.length < 3) {
        return;
      }
      if (this.newTraineeSearchDebounce) {
        clearTimeout(this.newTraineeSearchDebounce);
        this.newTraineeSearchDebounce = null;
      }
      this.newTraineeSearchDebounce = setTimeout(() => {
        val &&
        val !== this.newTraineesSelect &&
        this.newTraineeQuerySelections(val);
      }, 400);
    },
    newTraineesSelect(val) {
      val != null
          ? ((this.newTraineeCourseDialog = true),
              (this.newTraineeNotFound = false),
              (this.newTrainee = val))
          : (this.newTraineeCourseDialog = false);
    },
  },
  computed: {
    statusOptions() {
      if (this.categoryTypeValue !== "CAT2") return this.STATUS;
      return this.STATUS
          .filter((status) => status.id !== "FAIL")
          .map((status) => status.id === "PENDING" ? {...status, name: "Pending"} : status);
    },
    fields() {
      if (!this.select) return [];

      return this.select;
    },
    newTraineeTableHeaders() {
      if (this.categoryTypeValue === "CAT2") {
        return this.newTraineeheaders.filter((header) => header.value !== "courseScore");
      }
      return this.newTraineeheaders;
    },
    canCreateTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canCreate
      );
    },
    // canEditTrainee() {
    //   return getUser().permissions.some(
    //       (permission) =>
    //           permission.menuItem.menuItemName == "Trainee" && permission.canUpdate
    //   );
    // },
    canViewTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canRead
      );
    },
    canApproveCertificate() {
      return hasCertificateApprovalPermission();
    },
    canSignCertificate() {
      return hasCertificateSigningPermission();
    },
    isPendingStatusFilter() {
      return this.statusValue === "PENDING";
    },
    isCompletedStatusFilter() {
      return this.statusValue === "COMPLETED";
    },
    canShowApprovalActions() {
      return this.canApproveCertificate && (!this.statusValue || this.isPendingStatusFilter);
    },
    canShowBulkCertificateActions() {
      return this.canViewTrainee && this.isCompletedStatusFilter;
    },
    selectableNewTraineeRows() {
      const rows = Array.isArray(this.newTrainees?.rows) ? this.newTrainees.rows : [];
      return rows.map((item) => ({
        ...item,
        isSelectable: this.canSelectNewTraineeRow(item),
      }));
    },
    bulkCertificateItems() {
      if (Array.isArray(this.selected) && this.selected.length) {
        return this.selected.filter((item) => this.canSelectNewTraineeRow(item));
      }
      return this.selectableNewTraineeRows.filter((item) =>
          this.canSelectNewTraineeRow(item)
      );
    },
    bulkCertificateProgressPercent() {
      const total = Number(this.bulkCertificateProgress.total) || 0;
      const current = Number(this.bulkCertificateProgress.current) || 0;
      if (!total) return 0;
      return Math.max(0, Math.min(100, Math.round((current / total) * 100)));
    },
  },
  async beforeMount() {
    if (this.fromRoute === "Back") {
      this.tab = 0;
    } else if (this.fromRoute === "Add") {
      this.tab = 1;
    } else {
      this.tab = 0;
    }
    this.initLookups();

  },
  methods: {
    resolveNewTraineeCourse(item) {
      if (!item) return null;
      return item.newt_cat2_course || item.new_trainees_course || null;
    },
    resolveNewTraineeCourseType(item) {
      if (!item) return null;
      if (item.newt_cat2_course) return "cat2";
      if (item.new_trainees_course) return "cat1";
      return null;
    },
    isCat2NewTrainee(item) {
      return this.resolveNewTraineeCourseType(item) === "cat2";
    },
    getNewTraineeScoreDisplay(item) {
      const course = this.resolveNewTraineeCourse(item);
      const score = course?.score;
      return score === null || score === undefined || score === "" ? "-" : score;
    },
    scoreKeyForNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      const type = this.resolveNewTraineeCourseType(item);
      const id = course?.id;
      if (!type || !id) return null;
      return `${type}:${id}`;
    },
    getScoreEditForNewTrainee(item) {
      const key = this.scoreKeyForNewTrainee(item);
      if (!key) return "";
      if (Object.prototype.hasOwnProperty.call(this.scoreEdits, key)) {
        return this.scoreEdits[key];
      }
      const course = this.resolveNewTraineeCourse(item);
      const initial = course?.score ?? "";
      this.$set(this.scoreEdits, key, initial);
      return initial;
    },
    onScoreInputNewTrainee(item, value) {
      const key = this.scoreKeyForNewTrainee(item);
      if (!key) return;
      this.$set(this.scoreEdits, key, value);
    },
    isScoreSavingNewTrainee(item) {
      const key = this.scoreKeyForNewTrainee(item);
      if (!key) return false;
      return !!this.scoreSaving[key];
    },
    resolveProgramEndDateNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      return course?.program?.endDate || null;
    },
    hasGeneratedCertificateNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return false;
      return isCertificateApprovalComplete(course);
    },
    isProgramEndedNewTrainee(item) {
      const endDate = this.resolveProgramEndDateNewTrainee(item);
      if (!endDate) return false;
      const end = new Date(endDate);
      if (Number.isNaN(end.getTime())) return false;
      const today = new Date();
      end.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return end <= today;
    },
    resolvePassingScoreNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return null;
      const selectedLevel = course?.course?.courseLevels?.find(
          (level) => Number(level.courseLevelId) === Number(course?.program?.courseLevelId)
      );
      const cat1Passing = selectedLevel?.passingScore ?? course?.course?.passingScore;
      const cat2Passing = course?.program?.cat2PassingScore;
      const value = cat1Passing ?? cat2Passing ?? null;
      if (value === null || value === undefined || value === "") return null;
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    },
    canEditScoreNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return false;
      if (this.isCat2NewTrainee(item)) return false;
      if (this.hasGeneratedCertificateNewTrainee(item)) return false;
      if (this.isScoreLockedByCertificateNew(item)) return false;
      if (!this.isProgramEndedNewTrainee(item)) return false;
      return this.resolvePassingScoreNewTrainee(item) !== null;
    },
    isPassedNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return false;
      const passId = Number(this.traineStatusIds?.passId);
      if (!passId) return false;
      return Number(course?.traineeStatusId) === passId;
    },
    isFailedNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return false;
      const failId = Number(this.traineStatusIds?.failId);
      if (!failId) return false;
      return Number(course?.traineeStatusId) === failId;
    },
    handleFailedNewTraineeClick(item) {
      if (!this.isFailedNewTrainee(item)) return;
      this.$toast.warning("This trainee has failed.");
    },
    canGenerateCertificateNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      return Boolean(course) && this.isPassedNewTrainee(item);
    },
    isCertificateApprovedCourse(course) {
      return isCertificateApprovalComplete(course);
    },
    isCertificateApprovedNewTrainee(item) {
      const course = this.resolveNewTraineeCourse(item);
      return this.isCertificateApprovedCourse(course);
    },
    canSelectNewTraineeRow(item) {
      if (this.canShowBulkCertificateActions) {
        return this.isCertificateApprovedNewTrainee(item);
      }
      if (this.canShowApprovalActions) {
        return this.isPendingApprovalTrainee(item);
      }
      return true;
    },
    isScoreLockedByCertificateNew(item) {
      if (!this.canGenerateCertificateNewTrainee(item)) return false;
      return !this.isCertificatePendingApprovalNew(item);
    },
    canEditCertificateReasonNew(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return false;
      return this.isPassedNewTrainee(item);
    },
    openCertificateReasonDialogNew(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return;
      this.certificateReasonForm.item = item;
      this.certificateReasonForm.reasonId =
          course?.certificateReasonId ?? course?.certificate_reason?.id ?? null;
      this.showCertificateReasonDialog = true;
    },
    closeCertificateReasonDialogNew() {
      this.showCertificateReasonDialog = false;
      this.certificateReasonForm = {
        item: null,
        reasonId: null,
      };
    },
    async saveCertificateReasonNew() {
      const item = this.certificateReasonForm.item;
      const reasonId = Number(this.certificateReasonForm.reasonId);
      if (!item || !reasonId) return;

      const course = this.resolveNewTraineeCourse(item);
      const type = this.resolveNewTraineeCourseType(item);
      if (!course || !type) return;

      const payload = {
        id: course.id,
        certificateReasonId: reasonId,
        traineeStatusId: course?.traineeStatusId ?? null,
      };

      this.certReasonLoading = true;
      try {
        if (type === "cat2") {
          await TraineeService.completeNewTCat2Course(payload);
        } else {
          await TraineeService.completeNewTraineeCourse(payload);
        }
        const selectedReason = this.CERTIFICATE_REASONS.find((reason) => Number(reason.id) === reasonId) || null;
        course.certificateReasonId = reasonId;
        course.certificate_reason = selectedReason;
        this.$toast.success("Certificate reason updated.");
        this.closeCertificateReasonDialogNew();
      } catch (e) {
        console.error(e);
        this.$toast.error("Unable to update certificate reason.");
      } finally {
        this.certReasonLoading = false;
      }
    },
    isCertificatePendingApprovalNew(item) {
      const course = this.resolveNewTraineeCourse(item);
      if (!course) return false;
      return isCertificateUnapproved(course);
    },
    getCertificateActionIconNew(item) {
      return this.isCertificatePendingApprovalNew(item)
          ? "mdi-clock-outline"
          : "mdi-file-certificate-outline";
    },
    getCertificateActionTooltipNew(item) {
      return this.isCertificatePendingApprovalNew(item)
          ? "Certificate Pending Approval"
          : "Generate Certificate";
    },
    async saveScoreNewTrainee(item) {
      const key = this.scoreKeyForNewTrainee(item);
      if (!key) return;
      if (this.hasGeneratedCertificateNewTrainee(item)) {
        this.$toast.error("Score cannot be edited after certificate is generated.");
        return;
      }
      if (this.isScoreLockedByCertificateNew(item)) {
        this.$toast.error("Score cannot be edited after certificate approval.");
        return;
      }
      if (!this.canEditScoreNewTrainee(item)) {
        this.$toast.error("Score entry is not allowed (CPD activity not ended or missing passing score).");
        return;
      }
      if (this.scoreSaving[key]) return;

      const entered = this.scoreEdits[key];
      const score = entered === "" || entered === null || entered === undefined ? null : Number(entered);
      if (score === null || !Number.isFinite(score)) {
        this.$toast.error("Please enter a valid score.");
        return;
      }
      if (score < 0 || score > 100) {
        this.$toast.error("Score must be between 0 and 100.");
        return;
      }

      const course = this.resolveNewTraineeCourse(item);
      const type = this.resolveNewTraineeCourseType(item);
      const passingScore = this.resolvePassingScoreNewTrainee(item);
      const passId = Number(this.traineStatusIds?.passId) || null;
      const failId = Number(this.traineStatusIds?.failId) || null;
      if (!passId || !failId || passingScore === null) {
        this.$toast.error("Missing trainee status configuration or passing score.");
        return;
      }

      const traineeStatusId = score >= passingScore ? passId : failId;
      const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10);

      const payload = {
        id: course.id,
        score,
        traineeStatusId,
        courseCompletionDate: today,
        certificateApprovalStatus: traineeStatusId === passId ? "PENDING" : null,
      };

      this.$set(this.scoreSaving, key, true);
      try {
        if (type === "cat2") {
          await TraineeService.completeNewTCat2Course(payload);
        } else {
          await TraineeService.completeNewTraineeCourse(payload);
        }

        // Keep UI responsive without requiring a full reload.
        course.score = score;
        course.traineeStatusId = traineeStatusId;
        course.courseCompletionDate = today;
        course.certificateApprovalStatus = payload.certificateApprovalStatus;

        this.$toast.success("Score saved.");
      } catch (e) {
        console.error(e);
        this.$toast.error("Unable to save score, please try again.");
      } finally {
        this.$set(this.scoreSaving, key, false);
      }
    },
    openBulkCertificateDialog() {
      if (this.selectionLoading || !this.canShowBulkCertificateActions) return;
      if (this.bulkCertificateItems.length === 0) {
        this.$toast.error("Please select trainees to generate certificates.");
        return;
      }
      this.bulkCertificateErrors = [];
      this.bulkCertificateProgress = {total: 0, current: 0};
      this.bulkCertificateMode = null;
      this.showBulkCertificateDialog = true;
    },
    closeBulkCertificateDialog() {
      if (this.bulkCertificateLoading) return;
      this.showBulkCertificateDialog = false;
      this.bulkCertificateErrors = [];
      this.bulkCertificateProgress = {total: 0, current: 0};
      this.bulkCertificateMode = null;
    },
    async previewSelectedCertificate() {
      if (this.bulkCertificateItems.length !== 1) return;
      if (this.bulkCertificateLoading) return;
      await this.generateCertificateForItem(this.bulkCertificateItems[0], {open: true, sendEmail: false});
    },
    async handleApprove() {
      if (this.selectionLoading) return;
      if (!this.canApproveCertificate) {
        this.$toast.error("Only the CEO can approve pending trainee certificates.");
        return;
      }
      if (!this.selected || this.selected.length === 0) {
        this.$toast.error("Please select trainees to approve.");
        return;
      }
      if (this.selected.some((item) => !this.isPendingApprovalTrainee(item))) {
        this.$toast.error("Approval is allowed only for Pass/Pending trainees.");
        return;
      }
      this.approvalOptions.sendEmail = false;
      this.showApprovalDialog = true;
    },
    async confirmApprove() {
      if (this.selectionLoading) return;
      if (!this.canApproveCertificate) {
        this.$toast.error("Only the CEO can approve pending trainee certificates.");
        return;
      }
      if (!this.selected || this.selected.length === 0) {
        this.$toast.error("Please select trainees to approve.");
        return;
      }
      if (this.approvalLoading) return;
      const pendingSelected = this.selected.filter((item) =>
          this.isPendingApprovalTrainee(item)
      );
      if (pendingSelected.length !== this.selected.length) {
        this.$toast.error("Approval is allowed only for Pass/Pending trainees.");
        return;
      }

      const missingCourse = pendingSelected.filter((item) =>
          !(item?.new_trainees_course || item?.newt_cat2_course)
      );
      if (missingCourse.length > 0) {
        this.$toast.error("Selected trainees are missing course details.");
        return;
      }

      if (this.approvalOptions.sendEmail) {
        const missingEmail = pendingSelected.filter((item) => !this.resolveTraineeEmail(item));
        if (missingEmail.length > 0) {
          this.$toast.error("Trainee email is required to send certificates.");
          return;
        }
      }

      this.approvalLoading = true;
      try {
        const trainee = pendingSelected.map((e) => {
          return {id: e.id, category: e.newt_cat2_course ? "cat2" : "cat1"};
        });
        const response = await TraineeService.approveCertificates("new", {trainee});
        const responseBody = response?.data || {};
        if (response?.status !== 200 && response?.status !== 201) {
          this.$toast.error("Unable to approve certificates.");
          return;
        }
        if (responseBody?.status && responseBody.status !== 200) {
          this.$toast.error(responseBody?.message || "Unable to approve certificates.");
          return;
        }

        for (const item of pendingSelected) {
          this.$set(this.getSelectedCourse(item), "certificateApprovalStatus", "COMPLETED");
        }
        if (this.approvalOptions.sendEmail) {
          for (const item of pendingSelected) {
            await this.generateCertificateForItem(item, {open: false, sendEmail: true});
          }
        }

        this.$toast.success(responseBody?.message || "Certificates approved successfully.");
        this.showApprovalDialog = false;
        this.selected = [];
        this.fetchNewTraineeCourseList();
      } finally {
        this.approvalLoading = false;
      }
    },
    closeApprovalDialog() {
      this.showApprovalDialog = false;
      this.approvalOptions.sendEmail = false;
    },
    approveSingle(item) {
      if (!item) return;
      if (!this.canShowRowApprovalAction(item)) {
        this.$toast.error("Approval is allowed only for Pass/Pending trainees.");
        return;
      }
      this.selected = [item];
      this.approvalOptions.sendEmail = false;
      this.showApprovalDialog = true;
    },
    canShowRowApprovalAction(item) {
      return this.canApproveCertificate && this.isPendingApprovalTrainee(item);
    },
    canShowRowSigningAction(item) {
      return this.canSignCertificate && this.isPendingCoordinatorSignatureTrainee(item);
    },
    async signSingle(item) {
      if (!this.canShowRowSigningAction(item)) {
        this.$toast.error("Only certificates awaiting the CPD Coordinator signature can be signed.");
        return;
      }
      const trainee = [{
        id: item.id,
        category: item.newt_cat2_course ? "cat2" : "cat1",
      }];
      const response = await TraineeService.signCertificates("new", {trainee});
      const responseBody = response?.data || {};
      if ((response.status === 200 || response.status === 201) && responseBody.status === 200) {
        this.$toast.success(responseBody.message || "Certificate signed successfully.");
        await this.fetchNewTraineeCourseList();
        return;
      }
      this.$toast.error(responseBody.message || "Unable to sign certificate.");
    },
    resolveTraineeEmail(item) {
      return resolveCertificateEmail(item);
    },
    isPendingApprovalTrainee(item) {
      const course = this.getSelectedCourse(item);
      return this.isPassedNewTrainee(item) && isCertificateUnapproved(course);
    },
    isPendingCoordinatorSignatureTrainee(item) {
      const course = item?.newt_cat2_course || item?.new_trainees_course;
      return course ? isCertificatePendingCoordinatorSignature(course) : false;
    },
    getSelectedCourse(item) {
      if (!item) return null;
      return item.newt_cat2_course || item.new_trainees_course || null;
    },
    async generateCertificateForItem(item, {open = true, sendEmail = false, allowPending = false} = {}) {
      const courseDetail = this.getSelectedCourse(item);
      if (!courseDetail) return;
      if (!allowPending && !this.isCertificateApprovedCourse(courseDetail)) {
        this.$toast.warning(
            "Certificate must be approved before it can be generated."
        );
        return;
      }

      if (sendEmail) {
        const email = this.resolveTraineeEmail(item);
        if (!email) {
          this.$toast.error("Trainee email is required to deliver the certificate.");
          return;
        }
      }

      const url = settings.FRONT_URL + "newTraineeInformation/" + item.id;
      const res = await TraineeService.generateQrCode({url});
      if (res.status === 200 || res.status === 201) {
        const qrImage = res.data?.data || res.data;
        await generateCertificate1(courseDetail, item, qrImage, {open, sendEmail, allowPending});
      } else {
        this.$toast.error("Unable to generate trainee certificate, please try again");
      }
    },
    async previewCertificate() {
      if (this.selected.length !== 1) return;
      if (this.previewLoading) return;
      this.previewLoading = true;
      try {
        await this.generateCertificateForItem(this.selected[0], {open: true, sendEmail: false, allowPending: true});
      } finally {
        this.previewLoading = false;
      }
    },
    safeFileName(item, courseDetail) {
      const name = item?.trainee
          ? `${item.trainee.firstName || ""} ${item.trainee.middleName || ""} ${item.trainee.lastName || ""}`
          : (item?.person
              ? `${item.person.firstname || ""} ${item.person.middlename || ""} ${item.person.lastname || ""}`
              : "trainee");
      const course = courseDetail?.course?.courseName || courseDetail?.program?.courseTitleCat2 || "certificate";
      return `${name}-${course}`.replace(/[^a-zA-Z0-9-_]+/g, "_").slice(0, 80) + ".pdf";
    },
    async runBulkCertificates(mode) {
      if (!this.canShowBulkCertificateActions) return;
      const items = this.bulkCertificateItems.slice();
      if (!items.length) {
        this.$toast.error("Please select trainees to generate certificates.");
        return;
      }
      if (this.bulkCertificateLoading) return;

      this.bulkCertificateMode = mode;
      this.bulkCertificateLoading = true;
      this.bulkCertificateErrors = [];
      this.bulkCertificateProgress = {total: items.length, current: 0};

      const flushUi = async () => {
        await this.$nextTick();
        await new Promise((resolve) => setTimeout(resolve, 0));
      };

      try {
        const zip = mode === "download" ? new JSZip() : null;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const courseDetail = this.getSelectedCourse(item);
          this.bulkCertificateProgress.current = i;
          await flushUi();

          if (!courseDetail) {
            this.bulkCertificateErrors.push("Some selected trainees are missing course details.");
            continue;
          }
          if (!this.isCertificateApprovedCourse(courseDetail)) {
            this.bulkCertificateErrors.push("Some certificates are not approved and were skipped.");
            continue;
          }
          if (mode === "email") {
            const email = this.resolveTraineeEmail(item);
            if (!email) {
              this.bulkCertificateErrors.push("Some selected trainees are missing email and were skipped.");
              continue;
            }
          }

          try {
            const url = settings.FRONT_URL + "newTraineeInformation/" + item.id;
            const qrRes = await TraineeService.generateQrCode({url});
            const qrImage = qrRes?.data?.data || qrRes?.data;
            if (mode === "download") {
              const pdfBlob = await generateCertificate1(courseDetail, item, qrImage, {
                open: false,
                sendEmail: false,
                returnBlob: true,
              });
              if (pdfBlob) {
                zip.file(this.safeFileName(item, courseDetail), pdfBlob);
              }
            } else {
              await generateCertificate1(courseDetail, item, qrImage, {
                open: false,
                sendEmail: true,
                returnBlob: false,
              });
            }
          } catch (e) {
            console.error(e);
            this.bulkCertificateErrors.push("Some certificates failed to process.");
          } finally {
            this.bulkCertificateProgress.current = i + 1;
            await flushUi();
          }
        }

        if (mode === "download" && zip) {
          const zipBlob = await zip.generateAsync({type: "blob"});
          saveAs(zipBlob, `trainee_certificates_${new Date().toISOString().slice(0, 10)}.zip`);
        }

        if (mode === "email") {
          this.$toast.success("Certificate emails processed.");
        } else {
          this.$toast.success("Certificates generated.");
        }
        this.showBulkCertificateDialog = false;
        this.selected = [];
      } finally {
        this.bulkCertificateLoading = false;
        this.bulkCertificateMode = null;
        this.bulkCertificateProgress = {total: 0, current: 0};
      }
    },
    async viewCertificateFromRow(item) {
      // Always allow click, but enforce eligibility with clear feedback.
      const courseDetail = this.getSelectedCourse(item);
      if (!courseDetail) {
        this.$toast.error("Missing course details for this trainee.");
        return;
      }
      if (isCertificateUnapproved(courseDetail)) {
        this.$toast.warning("Certificate is pending approval.");
        return;
      }
      this.$toast.info("Certificate is generating...");
      await this.generateCertificateForItem(item, {open: true, sendEmail: false});
    },

    async initLookups() {
      this.categoryLoading = true;
      this.CATEGORIES = await getCategories();
      this.categoryLoading = false;
      await this.fetchCertificateReasonsNew();

      this.fetchCpdActivity();
      this.fetchNewTraineeCourseList();
      this.fetchTraineeStatus();
    },
    async fetchCertificateReasonsNew() {
      this.certReasonLoading = true;
      const certResp = await getCertReason();
      this.CERTIFICATE_REASONS = certResp?.rows
          ? certResp.rows.filter((row) => row.isActive === true)
          : [];
      this.certReasonLoading = false;
    },
    async fetchCpdActivity(id = null) {
      this.cpdActLoading = true;
      const programs = await getProgramsDrp(id);
      this.CPD_ACTIVITIES = programs.data;
      this.cpdActLoading = false;
    },
    canEditTrainee(item) {
      return !item && (getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canUpdate
      ));
    },
    formatDate(item) {
      const date = new Date(item.birthdate);
      return date;
    },
    viewTrainee(item) {
      this.trainee = item;
      this.detailDialog = true;
      this.title = "Trainee's Course Detail";
    },
    viewNewTrainee(item) {
      this.handleFailedNewTraineeClick(item);
      this.newTrainee = item;
      this.newTCourseDetailDialog = true;
      this.title = "New Trainee's Course Detail";
    },
    goToTraineeRegistration() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "Add"},
      });
    },
    goToTraineeHistory() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "History"},
      });
    },
    closeDialog(isNewTrainee) {
      this.detailDialog = false;
      this.newTraineeCourseDialog = false;
      this.newTCourseDetailDialog = false;
      this.dialog = false;
      isNewTrainee ? this.fetchNewTraineeCourseList() : this.fetchTraineeList();
    },
    async querySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.items = res.data;

        if (v != null && this.items.length === 0) {
          this.traineeNotFound = true;
        }

        this.items.map((item) => {
          item.fullName =
              item.firstname + " " + item.middlename + " " + item.lastname;
        });
        return this.items;
      } else {
        this.loading = false;

        return this.items;
      }
    },
    async newTraineeQuerySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchNewTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.newTraineeItems = res.data;

        if (v != null && this.newTraineeItems.length === 0) {
          this.newTraineeNotFound = true;
        }

        this.newTraineeItems.map((item) => {
          item.fullName =
              item.firstName + " " + item.middleName + " " + item.lastName;
        });
        return this.newTraineeItems;
      } else {
        this.loading = false;

        return this.newTraineeItems;
      }
    },
    normalizeDisplayValue(value) {
      if (value === null || value === undefined) return "";
      if (typeof value === "string") return value.trim();
      if (typeof value === "number") return String(value);
      if (typeof value === "boolean") return value ? "Yes" : "No";
      if (Array.isArray(value)) {
        return value
            .map((item) => this.normalizeDisplayValue(item))
            .filter(Boolean)
            .join(" ")
            .trim();
      }
      if (typeof value === "object") {
        return (
            this.normalizeDisplayValue(value.fullName) ||
            this.normalizeDisplayValue(value.name) ||
            this.normalizeDisplayValue(value.value) ||
            this.normalizeDisplayValue(value.label)
        );
      }
      return "";
    },
    getNewTraineeSearchLabel(item) {
      if (!item) return "-";
      const fullName =
          this.normalizeDisplayValue(item.fullName) ||
          [
            this.normalizeDisplayValue(item.firstName),
            this.normalizeDisplayValue(item.middleName),
            this.normalizeDisplayValue(item.lastName),
          ].filter(Boolean).join(" ") ||
          "-";
      const meta = [
        this.normalizeDisplayValue(item.phoneNumber) && `Phone: ${this.normalizeDisplayValue(item.phoneNumber)}`,
        this.normalizeDisplayValue(item.national_id) && `FAN: ${this.normalizeDisplayValue(item.national_id)}`,
        this.normalizeDisplayValue(item.licenseNumber) && `License: ${this.normalizeDisplayValue(item.licenseNumber)}`,
      ].filter(Boolean);
      return meta.length ? `${fullName} | ${meta.join(" | ")}` : fullName;
    },
    async registerOrUpdateTrainee(trainee) {
      this.historyLoading = true;
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.update(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.create(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    async registerOrUpdateNewTrainee(trainee) {
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.updateNewTraineeCourse(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.createNewTraineeCourse(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    refreshTraineeDetail() {
      this.fetchTraineeList();
      this.fetchNewTraineeCourseList();
      this.fetchTraineeStatus();
    },
    async fetchTraineeStatus() {
      this.traineeStatus = await TraineeService.getTraineeStatus();
      this.traineeStatus.data.filter((e) => {
        this.traineStatusIds.passId =
            e.code == "PASS" ? e.id : this.traineStatusIds.passId;
        this.traineStatusIds.failId =
            e.code == "FAIL" ? e.id : this.traineStatusIds.failId;
      });
      if (this.statusValue !== null) this.fetchNewTraineeCourseList();
    },
    async fetchTraineeList() {
      this.historyLoading = true;
      console.log('here')
      // let dates={}
      // this.startDate!==''&&(dates.startDate=this.startDate);
      // this.endDate!==''&&(dates.endDate=this.endDate);

      const {page, itemsPerPage} = this.hraOptions;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      // this.nonAccCpd !== null && (searchParams += '&trainingCenterId=' + this.nonAccCpd);
      // this.nonAccName !== null && (searchParams += '&name=' + this.nonAccName);
      const res = await TraineeService.getHraTraineeAssignList(params);
      if (res.status === 200) {
        this.trainees = res.data;
      }
      this.historyLoading = false;
    },
    getTraineeListParams(pagination = this.options) {
      const {page, itemsPerPage} = pagination;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      const nameValue = this.filterTrainee ? this.filterTrainee.trim() : null;
      nameValue && (params += '&name=' + encodeURIComponent(nameValue));
      this.startDate !== null && (params += '&startDate=' + this.startDate);
      this.endDate !== null && (params += '&endDate=' + this.endDate);
      this.categoryId !== null && (params += '&categoryId=' + this.categoryId);
      this.cpdActivityId !== null && (params += '&cpdActivityId=' + this.cpdActivityId);
      params += traineeStatusQuery(this.statusValue, this.traineStatusIds);
      this.categoryTypeValue !== null && (params += '&categoryType=' + this.categoryTypeValue);

      return params;
    },
    async fetchNewTraineeCourseList() {
      this.newTraineeLoading = true;
      try {
        const res = await TraineeService.getNewTraineeAssignList(this.getTraineeListParams());
        if (res.status === 200) {
          this.newTrainees = res.data;
        }
      } finally {
        this.newTraineeLoading = false;
      }
    },
    editTrainee(item) {
      this.dialog = true;
      this.trainee = item;
      this.title = "Edit Trainee's Course";
    },
    editNewTrainee(item) {
      this.newTraineeCourseDialog = true;
      this.newTrainee = item;
      this.title = "Edit New Trainee's Course";
    },
  },
};
</script>

<style scoped>
.trainee-alert {
  border-radius: 12px;
  background: #f8fafc;
  border-color: rgba(15, 23, 42, 0.12) !important;
  color: #0f172a;
}

.trainee-alert ::v-deep .v-alert__icon {
  color: #1976d2;
}

.trainee-alert__button {
  background: #e2e8f0 !important;
  color: #0f172a !important;
  text-transform: none;
  font-weight: 600;
}

.trainee-toolbar {
  border-radius: 12px;
  background: #1e293b !important;
  border: 1px solid rgba(15, 23, 42, 0.12);
}

.trainee-toolbar__search ::v-deep .v-input__slot {
  background: #ffffff !important;
  border-radius: 10px;
}

.trainee-toolbar__search ::v-deep .v-label {
  color: #475569 !important;
}

.trainee-section {
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
  overflow: hidden;
}

.trainee-section__title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  background: #f8fafc;
}

.trainee-filter-grid {
  width: 100%;
  gap: 8px;
}

@media (min-width: 960px) {
  .trainee-filter-grid {
    flex-wrap: nowrap !important;
  }
}

.trainee-approve-row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0 16px 12px;
}

.trainee-approve-button {
  text-transform: none;
  font-weight: 600;
  background: #1976d2 !important;
  border-color: #1976d2 !important;
}

.trainee-table {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.trainee-table ::v-deep thead th {
  background: #f1f5f9;
  color: #475569;
  font-weight: 600;
}

.trainee-action-icon {
  color: #1976d2 !important;
}

.trainee-score-label {
  font-weight: 600;
}

.trainee-score-label--failed {
  color: #c62828;
  cursor: pointer;
}

.trainee-score-cell--failed {
  cursor: pointer;
}

.trainee-score-input--failed ::v-deep input {
  color: #c62828 !important;
  font-weight: 700;
}

.trainee-dialog-card {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.16);
}

.trainee-dialog__title {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: linear-gradient(135deg, #1e293b 0%, #2563eb 100%);
  color: #ffffff;
  padding: 18px 24px;
}

.trainee-dialog__icon {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  padding: 8px;
}

.trainee-dialog__text {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.2px;
  flex: 1 1 auto;
  min-width: 0;
  white-space: normal;
}

.trainee-dialog__close {
  margin-left: auto;
}

.trainee-dialog__close .v-icon {
  color: #ffffff !important;
}

@media (max-width: 700px) {
  .trainee-toolbar {
    margin-left: 16px;
    margin-right: 16px;
  }
}
</style>
